import { memo } from "react";

import PropTypes from "prop-types";

import { compose } from "redux";

export function DiverstImg(props) {
  const {
    className,
    data,
    contentType = "image/jpeg",
    maxWidth,
    maxHeight,
    minWidth,
    minHeight,
    placeholderComponent,
    width,
    height,
    alt,
    styles,
    base64Src,
    emptyVariant = "ignore",
  } = props;

  function image() {
    if (data) {
      return (
        <img
          className={className}
          src={base64Src ? `data:${contentType};base64,${data}` : data}
          alt={alt || ""}
          style={{
            maxWidth,
            maxHeight,
            minWidth,
            minHeight,
            width,
            height,
            ...styles,
          }}
        />
      );
    }
    if (placeholderComponent && emptyVariant === "placeholder") {
      return placeholderComponent;
    }
    if (emptyVariant === "placeholder" || emptyVariant === "reserve") {
      return (
        <svg width={maxWidth} height={maxHeight} viewBox="0 0 100 100">
          {emptyVariant === "placeholder" && (
            <rect width="100" height="100" rx="10" ry="10" fill="#EEE" />
          )}
        </svg>
      );
    }
    return <></>;
  }

  return <>{image()}</>;
}

DiverstImg.propTypes = {
  className: PropTypes.string,
  data: PropTypes.string,
  contentType: PropTypes.string,
  maxWidth: PropTypes.string,
  maxHeight: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  base64Src: PropTypes.bool,
  alt: PropTypes.string,
  styles: PropTypes.object,
  imgProps: PropTypes.object,
  emptyVariant: PropTypes.oneOf(["placeholder", "reserve", "ignore"]),
  placeholderComponent: PropTypes.element,
};

export default compose(memo)(DiverstImg);
